<template>
  <div class="flex min-h-screen flex-col">
    <div id="toast-wrapper" class="fixed z-50">
      <TheToast to="#toast-wrapper" />
    </div>

    <div class="flex flex-1 flex-col">
      <MinimalHeader :hidden="scrollState.isScrolledDown" />

      <div class="flex flex-1 flex-col">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'

import MinimalHeader from '@/scopes/navigation/components/MinimalHeader.vue'
import { useScrollState } from '~/scopes/customer-care/common/composables/useScrollState'

useHead({
  htmlAttrs: {
    lang: useI18nLocale(),
  },
})

const { scrollState } = useScrollState()
</script>
